<template>
  <div>

    <!-- テーマ選択 -->
    <v-section-panel useBreak v-if="themeSelected">
      <template v-slot:title> テーマ範囲（※複数選択可）<font color="#ff4a3d" size="2">❇︎</font></template>
      <template v-slot:content>
        <v-choice-themelist />
      </template>
    </v-section-panel>

    <!-- 範囲ラジオボタン -->
    <v-section-panel useBreak>
      <template v-slot:title> 範囲 <font color="#ff4a3d" size="2">❇︎</font></template>
      <template v-slot:content>
        <v-choice-question-range />
      </template>
    </v-section-panel>

    <!-- 範囲入力欄: ページから選択 -->
    <v-section-panel useBreak v-if="fromPage && (isShowPagesTango || isShowPagesRengo)">
      <template v-slot:title> </template>
      <template v-slot:content>
        <v-page-number-range />
      </template>
    </v-section-panel>

    <!-- 範囲入力欄: 単元から選択 -->
    <v-section-panel useBreak v-if="fromTangen && (isShowPagesTango || isShowPagesRengo)">
      <template v-slot:title> </template>
      <template v-slot:content>
        <v-choice-tangenlist />
      </template>
    </v-section-panel>

    <!-- 範囲入力欄: 見出しから選択 -->
    <v-section-panel useBreak v-if="fromMidashi && (isShowPagesTango || isShowPagesRengo)">
      <template v-slot:title> </template>
      <template v-slot:content>
        <v-page-number-range-midashi />
      </template>
    </v-section-panel>

    <!-- 設問数  -->
    <v-section-panel useBreak>
      <template v-slot:title> </template>
      <template v-slot:content>
        <v-question-number-options />
      </template>
    </v-section-panel>

    <!-- ソート -->
    <v-section-panel useBreak>
      <template v-slot:title> ソート <font color="#ff4a3d" size="2">❇︎</font></template>
      <template v-slot:content>
        <v-choice-question-order />
      </template>
    </v-section-panel>

    <!-- 解説 -->
    <v-section-panel useBreak v-if="isGetthrough === true">
      <template v-slot:title> 解説 <font color="#ff4a3d" size="2">❇︎</font></template>
      <template v-slot:content>
        <v-choice-question-description />
      </template>
    </v-section-panel>

    <!-- ロゴ設定 -->
    <v-section-panel useBreak v-if="hasLogo">
      <template v-slot:title> ロゴ <font color="#ff4a3d" size="2">❇︎</font></template>
      <template v-slot:content>
        <v-choice-logo />
      </template>
    </v-section-panel>

    <!-- プリント名 -->
    <v-section-panel useBreak>
      <template v-slot:title> プリント名 <font color="#ff4a3d" size="2">❇︎</font></template>
      <template v-slot:content>
        <v-select-print-title />
      </template>
    </v-section-panel>

  </div>
</template>

<script>
import VSectionPanel from '@/components/molecules/SectionPanel'

import VChoiceQuestionRange from '@/components/molecules/ChoiceQuestionRange'
import VChoiceTangenlist from '@/components/molecules/ChoiceTangenlist'
import VChoiceThemelist from '@/components/molecules/ChoiceThemelist'
import VQuestionNumberOptions from '@/components/organizms/QuestionNumberOptions'
import VChoiceQuestionOrder from '@/components/molecules/ChoiceQuestionOrder'
import VPageNumberRange from '@/components/molecules/PageNumberRange'
import VPageNumberRangeMidashi from '@/components/molecules/PageNumberRangeMidashi'
import VChoiceQuestionDescription from '@/components/molecules/ChoiceQuestionDescription'
import VChoiceLogo from '@/components/molecules/ChoiceLogo'
import VSelectPrintTitle from '@/components/molecules/SelectPrintTitle'

export default {
  components: {
    VSectionPanel,
    VChoiceQuestionRange,
    VChoiceTangenlist,
    VChoiceThemelist,
    VQuestionNumberOptions,
    VChoiceQuestionOrder,
    VPageNumberRange,
    VPageNumberRangeMidashi,
    VChoiceQuestionDescription,
    VChoiceLogo,
    VSelectPrintTitle,
  },

  props: {
    isGetthrough: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    rules: [
      value => !value.match(/[^0-9]/) || '数字のみで入力してください',
    ],
  }),

  computed: {
    themeSelected() {
      return this.$store.state.conditions.selectedCategory != '' && this.$store.state.conditions.selectedCategory === 3
    },

    fromPage() {
      return this.$store.state.conditions.selectedQuestionRangeType === 1
    },
    fromTangen() {
      return this.$store.state.conditions.selectedQuestionRangeType === 2
    },
    fromMidashi() {
      return this.$store.state.conditions.selectedQuestionRangeType === 3
    },
    hasLogo() {
      return this.$store.state.user.hasLogo
    },
    // 単語範囲
    isShowPagesTango() {
      return this.$store.getters['conditions/isShowPagesTango']
    },
    // 連語範囲
    isShowPagesRengo() {
      return this.$store.getters['conditions/isShowPagesRengo']
    },
  },

  methods: {
  },
}
</script>

<style lang="stylus" scoped>
  .flexbox
    display flex

  .plus-btn
    box-sizing: border-box;
    font-weight bold
    text-align center
    padding 8px 0
    margin: 0;
    width: 2em;
    border-radius 3px
    cursor pointer
    position relative
    position: relative;
    color: #fff;
    background-color: #aaa;
</style>
